document.addEventListener("DOMContentLoaded", () => {

    const overlay = document.getElementById("combo-popup-overlay");
    if (!overlay) return;

    const popup = overlay.querySelector(".combo-popup");
    const closeBtn = document.getElementById("comboPopupClose");
    const popupBtn = document.getElementById("comboPopupButton");

    const delay = Number(overlay.dataset.delay || 4) * 1000;

    // show only once per session
    if (sessionStorage.getItem("comboPopupShown")) return;

    function openPopup() {

        document.body.style.overflow = "hidden";

        overlay.classList.add("active");

        // next frame animation trigger (smooth fix)
        requestAnimationFrame(() => {
            popup.classList.add("show");
        });

        sessionStorage.setItem("comboPopupShown", "true");
    }

    function closePopup() {

        popup.classList.remove("show");

        // wait animation end before hiding overlay
        const handler = (e) => {
            if (e.propertyName !== "transform") return;

            overlay.classList.remove("active");
            document.body.style.overflow = "";

            popup.removeEventListener("transitionend", handler);
        };

        popup.addEventListener("transitionend", handler);
    }

    setTimeout(openPopup, delay);

    if (closeBtn) {
        closeBtn.addEventListener("click", closePopup);
    }

    overlay.addEventListener("click", (e) => {
        if (!popup.contains(e.target)) {
            closePopup();
        }
    });

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            closePopup();
        }
    });

    if (popupBtn) {
        popupBtn.addEventListener("click", closePopup);
    }

});